import { render, staticRenderFns } from "./myPerformance.vue?vue&type=template&id=9c060eac&scoped=true&"
import script from "./myPerformance.vue?vue&type=script&lang=js&"
export * from "./myPerformance.vue?vue&type=script&lang=js&"
import style0 from "./myPerformance.vue?vue&type=style&index=0&id=9c060eac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c060eac",
  null
  
)

component.options.__file = "myPerformance.vue"
export default component.exports